const isCalendarDate = (value) =>
  typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value);

const utcDay = (value, endOfDay) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const dayStart = isCalendarDate(value)
    ? date.getTime()
    : Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  return new Date(endOfDay ? dayStart + 86400000 - 1 : dayStart).toISOString();
};

export const utcDayStart = (value) => utcDay(value, false);

export const utcDayEnd = (value) => utcDay(value, true);

export const utcDayLabel = (value) =>
  new Date(value).toLocaleDateString(undefined, { timeZone: "UTC" });

export const utcDayInputValue = (value) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString().slice(0, 10);
};

export const pickerDate = (event) =>
  event.date ? event.date.toDate() : $(event.currentTarget).find("input").val();
